var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBorderLeftMenucopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.883,
    height: 148.117,
    viewBox: "0 0 17.883 38.117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11656",
    "data-name": "Group 11656",
    transform: "translate(-65.002 -199.049)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47402",
    "data-name": "Path 47402",
    d: "M0-.247v133.9",
    transform: "translate(65.5 199.296)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47398",
    "data-name": "Path 47398",
    d: "M18911.5,1990.163s1.754,15.5,17.326,13.674",
    transform: "translate(-18846 -1764)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47399",
    "data-name": "Path 47399",
    d: "M18911.5,1990.163s1.754,15.5,17.326,13.674",
    transform: "translate(-18846 -1709.663)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderLeftMenucopy);
export default __webpack_public_path__ + "static/media/border-left-menu copy.309ee26c71d1c3bcff24d6d9d918e716.svg";
export { ForwardRef as ReactComponent };